<template>
  <svg width="281" height="65" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14.501 68.488C10.156 47.19 5.605-4.86 31.504 16.544 63.877 43.3 128.558 78.916 127.06 43.261c-1.498-35.654 48.441-15.76 149.441 31.74"
      stroke="#B1A8D3"
      stroke-width="21"
    />
  </svg>
</template>
